import api from '../api/axios';

export interface SectionEDetail {
  id: number;
  organization_id: number;
  project_id: number;
  scope_of_consultation:   string | null;
  stakeholders_invited:    string | null;
  consultation_modalities: string | null;
  comments_summary:        string | null;
  comments_consideration:  string | null;
  section_e: number;
  edit_by:    number | null;
  created_at: string | null;
  updated_at: string | null;
}

export type SectionEFieldKey =
  | 'scope_of_consultation'
  | 'stakeholders_invited'
  | 'consultation_modalities'
  | 'comments_summary'
  | 'comments_consideration';

export type SectionEUpdate = Partial<Record<SectionEFieldKey, string | null>>;

const BASE_URL = '/api/section-e';

const sectionEService = {
  getSectionEByProject: async (projectId: number): Promise<SectionEDetail | null> => {
    const res = await api.get<SectionEDetail | null>(`${BASE_URL}/by-project/${projectId}`);
    return res.data;
  },

  saveSectionE: async (projectId: number, data: SectionEUpdate): Promise<SectionEDetail> => {
    const res = await api.put<SectionEDetail>(`${BASE_URL}/${projectId}`, data);
    return res.data;
  },

  resetSectionE: async (projectId: number): Promise<void> => {
    await api.post(`${BASE_URL}/${projectId}/reset`);
  },
};

export default sectionEService;
